import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class File extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'File'
  // Define default properties here
  static instanceDefaults() {
    return {
      for: '',
      key: '',
      file_name: '',
      mime_type: ''
    }
  }
}

const servicePath = 'files'
const servicePlugin = makeServicePlugin({
  Model: File,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin